import React from "react"
import ConfrimIcon from "../../assets/img/Confirm.svg"
import removeIcon from "../../assets/img/removeIcon.svg"
import Translation from "../../services/translation.service"

const prefix = "stf_remove_offer_"
const DeletePopup = ({
  onClose = () => { },
  onDelete = () => { }
}) => {
  return (<div className="delete-popup-overlay">
    <div className="container">
      <img src={ConfrimIcon} alt="confirmIcon" />
      <p className="title">{Translation.keys[prefix + "title"]}</p>
      <p className="desc">{Translation.keys[prefix + "desc"]}</p>
      <div className="button-section">
        <button className="storefront-button-light" onClick={onClose}>
          {Translation.keys[prefix + "cancel"]}
        </button>
        <button className="storefront-button center-button" onClick={onDelete}>
          <img className="remove-icon" src={removeIcon} alt="deleteIcon" />
          {Translation.keys[prefix + "remove"]}
        </button>
      </div>
    </div>
  </div>)
}

export default DeletePopup